/**
 * Did the server answer? Every API request reports it (`lib/api`), so the
 * server line on the sign-in screen and in Settings > Server can say
 * "Connected to ..." only when it is true, and "Can't reach ..." when the
 * last request got no answer at all (QA DT-BUG-04).
 */
import { create } from 'zustand';

/** `unknown` until the first request finishes. */
export type Reach = 'unknown' | 'ok' | 'down';

export const useReach = create<{ server: Reach }>(() => ({ server: 'unknown' }));

/** Records the outcome of one request: an HTTP answer of any status, or none. */
export function noteReach(answered: boolean): void {
  const server: Reach = answered ? 'ok' : 'down';
  if (useReach.getState().server !== server) useReach.setState({ server });
}
